export enum ErrorSeverity {
  Info = 0,
  Warning = 1,
  Error = 2,
  Fatal = 3,
}